import GeneralCRUDModel, {
  ACTION_TYPES as CRUD_ACTION_TYPES,
} from "../general-crud";
import { thunk } from "easy-peasy";
import API from "API";

export const ACTION_TYPES = { ...CRUD_ACTION_TYPES };

export const PaymentStoreModel = {
  ...GeneralCRUDModel("/transactional/payments"),

  getContractPayments: thunk(async (actions, payload, helpers) => {
    actions.setProcess(ACTION_TYPES.FETCHING_DATA);
    try {
      const data = await API.get(
        `/transactional/contracts/${payload.ContractId}/payments`
      );
      actions.setData(data);
      actions.setProcess(ACTION_TYPES.FETCHED_DATA);
    } catch (error) {
      console.error("Error while fetching data -> ", error);
      actions.setError(error);
    }
    actions.setProcess(ACTION_TYPES.FINISHED);
  }),
};
